import React, { useContext, useEffect, useState } from 'react';
import {
  getInstitutionSubjectsById,
  getTopicsBySubjectId,
  updateTopics,
  deleteTopics,
  getInstitutions,
  getAuthorizedPersonsProfile,
} from '../../../actions';
import { Context } from '../../../defaults';
import {
  Row,
  Col,
  Select,
  Empty,
  Form,
  Card,
  Descriptions,
  Popconfirm,
  Tooltip,
  message,
  Table,
} from 'antd';
import { CarryOutTwoTone, DeleteTwoTone, EditTwoTone } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { userRole } from '../../../common';

export const TopicsTable2 = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [institutions, setInstitutions] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState();
  const [selectedSubjects, setSelectedSubjects] = useState();
  const [selectedTopic, setSelectedTopic] = useState();
  const [subjectsList, setSubjectsList] = useState();
  const [edit, setEdit] = useState(false);

  const onSelectInstitution = (value) => {
    if (value) {
      setSelectedInstitution(value);
      setLoading(true);
      getInstitutionSubjectsById(value)
        .then(({ data }) => {
          setSubjectsList(data);
          setLoading(false);
        })
        .catch(() => {
          message.error(dictionary?.SomethingWentWrong[language]);
          setLoading(false);
        });
    }
  };

  const onSelectTopic = (id) => {
    setSelectedTopic(topics.filter((x) => x.id === id)[0]);
    setEdit(true);
  };
  const onSelectSubject = (value) => {
    if (value) {
      setSelectedSubjects(subjectsList.filter((x) => x.id === value)[0]);
      setLoading(true);
      getTopicsBySubjectId(value)
        .then(({ data }) => {
          setTopics(data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          message.error(dictionary?.SomethingWentWrong[language]);
        });
    }
  };

  const confirm = (id) => {
    deleteTopics(id)
      .then(() => {
        message.success(dictionary?.OperationSuccessful[language]);
        setSelectedSubjects(null);
        onSelectInstitution(selectedInstitution)
        onSelectSubject(selectedSubjects.id)
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.SomethingWentWrong[language]);
      });
  };

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    setSelectedTopic({ ...selectedTopic, [name]: value });
  };

  const saveEditedTopic = () => {
    if (selectedTopic.name) {
      setEdit(false);
      updateTopics(selectedTopic)
        .then(res => {
          onSelectInstitution(selectedInstitution)
          setSelectedTopic('')
          onSelectSubject(selectedSubjects.id)
          message.success(dictionary?.SuccessfullyChanged[language]);
        })
        .catch(() => {
          setLoading(false);
          message.error(dictionary?.SomethingWentWrong[language]);
        });
    } else {
      message.error(dictionary?.FillTheAllRequiredFields[language]);
    }
  };

  const rules = (value) => {
    if (!value) return { validateStatus: 'error', help: dictionary?.RequiredField[language] };
    else return { validateStatus: 'success', help: null };
  };

  const columns = [
    {
      title: `${dictionary?.TopicName[language]}`,
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
    },
    // {
    //   title: `${dictionary?.Subject[language]}`,
    //   dataIndex: 'subjectId',
    //   key: 'subjectId',
    //   render: (subjectId) => subjectsList && subjectsList.find((el) => el.id === subjectId)?.name,
    // },
    // {
    //   title: `${dictionary?.UserWhoCreated[language]}`,
    //   dataIndex: 'userLogin',
    //   key: 'userLogin',
    // },
    {
      title: `${dictionary?.Action[language]}`,
      key: 'action',
      width: 150,
      fixed: 'right',
      align: 'center',
      render: ({ id }) => (
        <>
          <Tooltip placement="top" title={dictionary?.Edit[language]}>
            <EditTwoTone key="edit" onClick={() => onSelectTopic(id)} />
          </Tooltip>
        </>
      ),
    },
    {
      title: `${dictionary?.Action[language]}`,
      key: 'action',
      width: 150,
      fixed: 'right',
      align: 'center',
      render: ({ id }) => (
        <>
          <Tooltip placement="top" title={dictionary?.Delete[language]}>
            <Popconfirm
              placement="bottom"
              title={dictionary?.AreYouSureToDelete[language]}
              onConfirm={() => confirm(id)}
              okText={dictionary?.Yes[language]}
              cancelText={dictionary?.No[language]}>
              <DeleteTwoTone key="delete" twoToneColor="#eb2f96" />
            </Popconfirm>
          </Tooltip>
        </>
      ),
    },
  ];

  useEffect(() => {
    getInstitutions().then(({ data }) => setInstitutions(data));

    if ('director' === userRole()) {
      setLoading(true);
      getAuthorizedPersonsProfile()
        .then(({ data }) => {
          onSelectInstitution(data?.institution?.id);
          setLoading(false);
        })
        .catch(() => {
          message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
          setLoading(false);
        });
    }
  }, []);

  return (
    <>
      <Row style={{ marginTop: '30px' }} gutter={16}>
        <Col span={16}>
          <Select
            placeholder={dictionary?.Institution[language]}
            allowClear={true}
            showSearch={true}
            style={{ width: '100%' }}
            disabled={'director' === userRole()}
            value={selectedInstitution}
            onChange={value => onSelectInstitution(value)}
            size='large'
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {!!institutions &&
              institutions.map((el) => {
                return (
                  <Select.Option value={el.id} key={`school${el.id}`}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder={dictionary?.Subjects[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            disabled={!selectedInstitution}
            value={selectedSubjects?.id}
            showSearch={true}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}
            onChange={onSelectSubject}>
            {subjectsList &&
              subjectsList.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
      </Row>
      {!selectedSubjects && <Empty style={{ marginTop: '100px' }} />}
      {selectedSubjects && (
        <Table
          style={{ marginTop: 24 }}
          scroll={{ x: 1300 }}
          columns={columns}
          dataSource={topics}
          rowKey="id"
        />
      )}
      {selectedTopic && (
        <Card
          style={{ marginTop: '30px' }}
          actions={[
            <Tooltip placement="top" title={dictionary?.Save[language]}>
              {edit && <CarryOutTwoTone key="edit" onClick={saveEditedTopic} />}
            </Tooltip>,
          ]}>
          <Descriptions size="default" title={dictionary?.EditTopic[language]} bordered column={12}>
            <Descriptions.Item label={dictionary?.TopicName[language]} span={12}>
              {edit && (
                <Form.Item hasFeedback {...rules(selectedTopic.name)}>
                  <TextArea
                    style={{ width: '100%' }}
                    size="middle"
                    name="name"
                    onChange={onInputChange}
                    maxLength={100}
                    value={selectedTopic.name}
                    showCount={true}
                    placeholder={dictionary?.TopicName[language]}
                  />
                </Form.Item>
              )}
              {!edit && selectedTopic.name}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      )}
    </>
  );
};
